import(/* webpackMode: "eager", webpackExports: ["LegalDocumentTracker"] */ "/vercel/path0/apps/web/components/legal/LegalDocumentTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WaitlistForm"] */ "/vercel/path0/packages/modules/identity/src/components/WaitlistForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandSquiggle"] */ "/vercel/path0/packages/ui/src/brand-squiggle.tsx");
